module.exports = __webpack_public_path__ + "static/media/1542318004302-2037956993 - Citizen Datasteward.139a2459.jpg";